import { useCallback } from 'react';
import useApi from './useApi';
import { useAppSettings } from '../hooks/useAppSettings';

export interface CoatingManufacturer {
    id: number;
    name: string;
}

export default () => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();

    const getCoatingManufacturers = useCallback(async () => {
        try {
            const apiUrl = appSettings?.api;
            if (!apiUrl) {
                throw new Error('API URL not configured in app settings');
            }
            await getApiData({
                endpoint: `${apiUrl}GetCoatingManufacturers`,
            });
        } catch (error) {
            console.error('Failed to fetch coating manufacturers:', error);
        }
    }, [getApiData, appSettings]);

    const getManufacturersData = (): CoatingManufacturer[] => {
        if (state.status === 'success' && state.result) {
            let rawData: any[] = [];
            if (Array.isArray(state.result)) {
                rawData = state.result;
            } else if (state.result.data && Array.isArray(state.result.data)) {
                rawData = state.result.data;
            }
            return rawData.map((item) => ({
                id: item.id ?? item.Id,
                name: item.name ?? item.Name,
            }));
        }
        return [];
    };

    return {
        manufacturers: getManufacturersData(),
        loading: state.isLoading,
        error: state.error,
        getCoatingManufacturers,
        status: state.status,
    };
};
